<script lang="ts" setup>
import type { BreadcrumbItemProps } from '.';

import { cn } from '@/utils';

const props = defineProps<BreadcrumbItemProps>();
</script>

<template>
	<li :class="cn('inline-flex items-center gap-1.5', props.class)">
		<slot />
	</li>
</template>
